<template>
  <div
    v-if="hasBadge"
    class="product-badge text-other-label-l-desktop text-other-label-s"
    :class="[productClass, {
      'oos': !product.available || !product.publishedProduct,
      'sale': hasSaleBadge
    }]"
    v-text="productBadge"
  />
</template>

<script>

/**
 * Vue: Product badge (product-badge)
 * -----------------------------------------------------------------------------
 * Product Badge.
 *
 */
export default {
  name: 'ProductBadge',

  props: {
    product: {
      type: [Boolean, Object],
      default: false,
    },
  },

  emits: ['render'],

  computed: {

    /**
     * Returns true if product unavailable or has badge tag.
     * @return {Boolean}
     */
    hasBadge() {
      return !this.product.available ||
        !this.product.publishedProduct ||
        this.product.tags.some(tag => tag.includes('badge:'))
    },

    /**
     * Returns badge text if product unavailable or has badge tag.
     * @return {String}
     */
    productBadge() {
      if (!this.hasBadge) {
        return ''
      }

      if (!this.product.publishedProduct) {
        return this.$string('product.badges.coming_soon')
      }

      return this.product.available
        ? this.product.tags.find(tag => tag.includes('badge:'))
          .replace(/(?:manual-)?badge: ?/, '')
        : this.$string('product.cta.sold_out')
    },

    /**
     * Returns badge CSS class if product is available and has badge tag.
     * @return {String}
     */
    productClass() {
      if (!this.hasBadge || !this.product.publishedProduct ||
        !this.product.available || this.hasSaleBadge) {
        return ''
      }

      const classString = this.product.tags.find(tag => tag.includes('badge:'))
        .replace(/(?:manual-)?badge: ?/, '')
        .replaceAll(' ', '-')
        .toLowerCase()
        .replace(/[^a-z0-9-]/g, '')

      return `product-badge--${classString}`
    },

    /**
     * Returns true if product has sale badge tag.
     * @return {Boolean}
     */
    hasSaleBadge() {
      return this.productBadge.includes('sale')
    },
  },

  mounted() {
    if (!this.productBadge) {
      return
    }

    this.$emit('render', this.productBadge.toLowerCase())
  },
}
</script>

<style lang="scss">
@import './product-badge';
</style>
